import Accordions from "./Components/Accordion";
import { useRef, useState, useEffect } from "react";
import { Accordion } from "react-headless-accordion";

export default function Policy() {
  const ref = useRef(null);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const el2 = ref.current;
    const collection = el2.getElementsByTagName("button");
    for (let i = 0; i < collection.length; i++) {
      const tag = collection.item(i);
      const attr = collection.item(i).getAttribute("aria-expanded");

      tag.childNodes.forEach((element) => {
        element.setAttribute("aria-expanded", attr);
        if (
          element.getAttribute("aria-expanded") === "true" &&
          element.getAttribute("alt") === "arrow"
        ) {
          element.style.transform = "rotate(180deg)";
        } else {
          element.style.transform = "rotate(360deg)";
        }
        if (
          element.getAttribute("aria-expanded") === "true" &&
          element.getAttribute("data-custom") === "circle"
        ) {
          element.firstChild.style.backgroundColor = "rgba(27, 27, 31, 0.5)";
        }
        if (
          element.getAttribute("aria-expanded") === "false" &&
          element.getAttribute("data-custom") === "circle"
        ) {
          element.firstChild.style.backgroundColor = "white";
        }
      });
    }
  }, [toggle]);
  return (
    <div className="container">
      <h1
        style={{
          marginTop: "6rem",
          borderBottom: "1px solid rgba(27, 27, 31, 0.5)",
          paddingBottom: "30px",
        }}
      >
        سياسة الاستبدال والاسترجاع
      </h1>
      <div
        className="collapes my-5"
        onClick={() => setToggle((prev) => !prev)}
        ref={ref}
      >
        {" "}
        <Accordion>
          <Accordions
            title="هل يمكنني ارجاع أو استبدال المياه بعد شراؤها؟"
            paragraph="نعم يمكنك إرجاع أو استبدال المياه في حال لم تكن راضٍ عن خدماتنا أو في حال وجود عيب واضح في التغليف او المياه داخل الكرتون"
          />
          <Accordions
            title="متى يمكنني إرجاع المياه بعد الشراء؟"
            paragraph="يمكنك ارجاع المياه خلال أسبوع من وقت الشراء المثبت في الفاتورة   بشرط ارجاعها بنفس حالتها الأصلية بدون استخدام"
          />
          <Accordions
            title="كيف يمكنني إرجاع المياه بعد الشراء"
            paragraph="فقط تواصل معنا على الرقم الموحد 920025555 وسيتم إفادتك بكامل إجراءات الاسترجاع"
          />
          <Accordions
            title="كيف أسترد المبلغ المدفوع؟"
            paragraph="في حال انطبقت شروط الإرجاع يتم تسليم المبلغ بنفس الطريقة التي تم بها الشراء .. في حالة النقد يتم إرجاع المبلغ فوراً عن تسليم المياه
          في حالة البطاقة الائتمانية يتم إرجاع المبلغ لنفس رقم البطاقة خلال 14 يوم عمل"
          />
          <Accordions
            title="قمت بارجاع البضاعة ولم يرجع المبلغ في حسابي بعد المدة المذكورة"
            paragraph="قم بمراجعة البنك التابع لك "
          />
          <Accordions
            title="هل توجد شروط للإرجاع ؟"
            paragraph="يجب أن تكون المياه بحالتها الأصلية وقت استلامها وفي حال وجود أي خلل ناتج عن سوء الاستخدام او التخزين نعتذر عن استلامها لأسباب صحية  كما يجب وجود الفاتورة الأصلية للشراء أو نسخة منها , في حال وجود عيب أو خلل في المنتج بسبب عيب مصنعي واضح يتم استبدالها أو استرجاعها حسب سياسة الشركة كما يمكن استرجاع جزء من المنتجات في الفاتورة الواحدة في حال ظهور عيب وصنعي واضح فقط لكن في حال الاسترجاع بدون سبب يجب استرجاع كامل المنتجات في الفاتورة  لإرجاع كامل المبلغ مع خصم مصروفات التوصيل حسب سياسة وزارة التجارة. "
          />
          <Accordions
            title="قمت بارجاع البضاعة ولم يرجع المبلغ في حسابي بعد المدة المذكورة"
            paragraph="قم بمراجعة البنك التابع لك "
          />
          <Accordions
            title="اشتريت منتج كان عليه تخفيض أو عرض هل يمكنني ارجاعه ؟"
            paragraph="للأسف لا يمكن استرجاع المنتجات التي تم شراؤها بواسطة عرض خاص أو تخفيض
          يمكن إضافة  قيمة المنتجات إلى محفظتك في تطبيق بيرين"
          />
          <Accordions
            title="هل توجد تكلفة يتم خصمها من مبلغ البضاعة ؟"
            paragraph="نعم .. يتم خصم تكلفة شحن المنتجات من موقعك للشركة  والتي نحددها الشركة حسب سياستها الداخلية وسيتم إفادتك بالتكلفة عند تواصلك للإرجاع          "
          />
          <Accordions
            title="طريقة الدفع باستخدام نقاط قطاف، والشروط المنظمة لذلك:"
            paragraph="1. يمكنك دفع كامل قيمة مشترياتك من بيرين، أو جزء منها باستخدام نقاط قطاف من شركة الاتصالات السعودية ( STC )، ويتم ذلك عن طريق الخطوات التالية:

          · قم بإختيار طريقة الد­فع بنقاط قطاف.
          
          · قم بإدخال المبلغ الذي تريد دفعة والبيانات في المكان المخصص لذلك.
          
          · قم بإدخال رمز التحقق الذي يُرسل من قطاف ( Qitaf) إلى رقم هاتفك المسجل لدى قطاف.
          
          2. نقاط قطاف المستبدلة لا يمكن إرجاعها مرة أخرى إلى رصيدك من نقاط قطاف لدى شركة الإتصالات السعودية ( STC ) ، ولكن يمكن إضافة تلك النقاط لمحفظتك لدى شركة بيرين، ويمكنك استخدامها في أي وقت تشاء، و بدون إنتهاء صلاحية.
          
          3. في حال قيامك بدفع جزء من قيمة المشتريات باستخدام نقاط قطاف، يتعين عليك اختيار طريقة إضافية لدفع كامل قيمة المشتريات.
          
          4. في حال قيامك بإلغاء طللب المشتريات، أو تعديله، أو لم يتم توصيله لأي سبب من الأسباب ، فإن قيمة الطلب المذكور تتحول تلقائياً إلى محفظتك لدى بيرين ،ويمكنك الإستفادة منها في أي وقت تشاء ، وبدون انتهاء صلاحية.
          
                     "
          />
          <Accordions
            title="الشروط والأحكام"
            paragraph="استخدامك لتطبيق / لموقع  بيرين وتقديمك معلوماتك الشخصية لنا هو بمثابة موافقة منك على البنود الواردة في سياسة الخصوصية، بالإشارة إلى “الشركة” أو “نحن” فإنها تمثل شركة بيرين والمسجلة في المملكة العربية السعودية، أما “أنت” أو “المستخدم” فإنها تمثل أي شخص يقوم باستخدام تطبيق أو موقع بيرين. إن كنت لا توافق على هذه البنود، فعليك التوقف عن استخدام التطبيق / الموقع الأن.

          هل معلوماتي آمنة؟
          
          في حال استخدامك للخدمة يجب أن تكون مطمئنًا أنّا نبذل أقصى ما في وسعنا لحماية بياناتك الشخصية ومنع الوصول غير القانوني أو غير المصرح به لها وحتى حمايتها من المعالجة والتغيير والفقدان. وعلى الرغم من اتخاذ إجراءات الحماية المتنوعة والعمل على تحسينها،
          
          نحن نُخلي مسؤوليتنا التامة عن أي خرق يحدث من طرف الاتصال الخاص بك أو من أطراف خارجة عن إرادتنا حيث لا يمكن لأي نظام أو تقنية أن تبقى في مأمن تام عن الأضرار، ولذلك إذا شعرت بأي ثغرة داخل التطبيق / الموقع ، يمكنك التواصل معنا للعمل على حل هذه المشكلة من خلال البريد الإلكتروني التالي care@berain.com.sa
          
          كيف تتم عملية معالجة الدفع الإلكتروني داخل التطبيق / الموقع ؟
          
          بيرين يستخدم طرف ثالث موثوق لمعالجة عمليات الدفع الإلكتروني، وهذه العمليات لا تنطبق على الأشخاص الذين يقومون باختيار “الدفع عند الاستلام” خلال عملية التسوق، من الممكن أن يقوم هذا الطرف الثالث بطلب معلومات خاصة ببطاقتك الائتمانية وربما يطلب منك الوصول لقائمة الاتصال الخاصة بك وقد نطلب بعض الأذونات لتحسين خدمتك مثل الحصول على احداثيات الموقع الخاص بك لتحصين عملية التوصيل.
          
          هل تقومون بمشاركة بياناتي الشخصية مع أي أطراف أخرى؟
          
          خصوصية مستخدمي بيرين أهم الأشياء التي نحاول حمايتها بكل الطرق الممكنة، حيث أننا لا نقوم إطلاقًا ببيع هذه البيانات ولكن قد يتم مشاركة بعض المعلومات الضرورية مع طرف ثالث لغرض تحسين تجربة استخدامك لخدماتنا، والأهداف التي نقوم بجمع هذه البيانات لها هي أهداف إحصائية وتسويقية لا غير كأعداد المستخدمين وأماكن انتفاعهم من الخدمة او المنتجات التي تم إبداء الاهتمام بها أو طلبها.
          
          ما هي الصلاحيات التي يطلبها النظام مني؟
          
          الوصول إلى حالة الهاتف: الوصول إلى إحداثيات موقعك وذلك لتسهيل عملية توصيل الطلبات وحساب الزمن اللازم لتوصيل الطلب إلى العنوان الخاص بك.
          
          في حال تصفحك للمتجر، لن نقوم بجمع أي بيانات شخصية عنك إلا حين تقرر استخدام الخدمة والانتفاع منها، وفي حال استخدامك لها فنحن نقوم على سبيل المثال بجمع البيانات الشخصية الموضحة أدناه:

الاسم
البريد الإلكتروني
رقم الجوال
المكان والعنوان “يتطلب ذلك تفعيل خاصية تحديد المواقع في بعض الأحيان”
بالإضافة إلى الكوكيز الخاص بتصفحك للموقع / التطبيق
          
          "
          />
          <Accordions
            title="كيف نستخدم البيانات الشخصية؟
          "
            paragraph="نحنُ نقوم بجمع البيانات الشخصية والتي سبق ذكرها للأسباب التالية:

          التسجيل في التطبيق
          تخصيص تجربتك في التطبيق للحصول على أفضل تجربة ممكنة لعملية التسوق مع بيرين
          التخطيط لمعرفة الوقت الذي سيتم استغراقه في عملية التوصيل
          اطلاعك على العروض الترويجية
          التواصل معك"
          />
          <Accordions
            title="هل بياناتي الشخصية في أمان؟

          "
            paragraph="نحنُ نقوم باستخدام تقنيات متقدمة جداً للحفاظ على خصوصية بياناتك ومنعها من الضياع أو السرقة أو القرصنة،          "
          />
          <Accordions
            title="هل يمكني تعديل بياناتي؟


          "
            paragraph="يمكنك تعديل بياناتك الشخصية من خلال الدخول إلى حسابك في التطبيق أو الموقع أو من خلال التواصل مع خدمة العملاء من خلال الضغط على زر اتصل بنا من القائمة الجانبية داخل التطبيق / الموقع

          ،          "
          />
          <Accordions
            title="حق تعديل شروط الاستخدام
          "
            paragraph="بيرين تملك الحق الكامل في تحديث شروط الاستخدام الخاصة بها سواء بإضافة أو حذف بنود جديدة أو بتعديل بنود حالية في أي وقت.          "
          />
          <Accordions
            title="كيف نقوم بإخطار مستخدمي بيرين بأي تحديث في شروط الاستخدام؟

          "
            paragraph="لن نقوم بإرسال أي إشعار أو بريد إلكتروني حول تحديثات شروط الاستخدام، ولكن يمكنك دائماً معرفة أي تحديث من خلال زيارة هذه الصفحة .

          .          "
          />
          <Accordions
            title="ما هو القانون الذي تخضع له الشروط؟
          "
            paragraph="تخضع شروط الاستخدام لقانون المملكة العربية السعودية، و موافقتك عليها تعني موافقتك على الخضوع للسلطة القضائية في المحاكم السعودية.
          "
          />
          <Accordions
            title="هل لديك أي استفسار؟
          "
            paragraph="إذا كانت لديك أي استفسارات أو أسئلة أو مخاوف حول هذه الشروط، فنحن نرحب دائماً بالإجابة على أسئلتكم و استفساراتكم، يمكنكم التواصل معنا مباشرة من خلال البريد الإلكتروني ب  care@berain.com.sa وسوف يتم الرد عليك  بأسرع وقت ممكن  care@berain.com.sa وسوف يتم الرد عليك  بأسرع وقت ممكن"
          />

          <Accordions
            title="ماهي الملفات المؤقتة (الكوكيز)؟
          "
            paragraph="الكوكيز هي ملفات نصية يتم إنشاؤها بواسطة مواقع الانترنت التي تزورها وتحتوي بيانات جلستك، ويمكن استخدامها لاحقاً بنفس الموقع. بحفظ بياناتك نشاطك بين الصفحات، ويمكنها أيضا تحليل الطريقة التي تتفاعل فيها مع الموقع.

          الكوكيز آمنة فهي تقوم فقط بتخزين بيانات يتم جمعها بواسطة المتصفح، أو التي يتم إدخالها بواسطة المستخدم  ويتم تضمينها في سجلات الصفحة .الكوكيز لا تتضمن أي أكواد برمجية ولا يمكن استخدامها للدخول إلى جهازك. إذا كان موقع انترنت قد قام بإنشاء ملفات كوكيز فإن هذا الموقع فقط هو من يمكنه قراءة واستخدام هذه الملفات.
          
           
          
          هناك نوعان من ملفات الكوكيز: ملفات مؤقتة وملفات دائمة وكلاهما يتم استخدامها لأغراض مختلفة ويحويان معلومات مختلفة.  "
          />
          <Accordions
            title="لماذا نستخدم (الملفات المؤقتة) الكوكيز؟


          "
            paragraph="ملفات الكوكيز يتم استخدامها بواسطة الموقع لتحافظ على معلومات زيارتك اثناء تصفح الموقع / التطبيق، وتبقى على اتصال لنتابع تفاصيل عمليات الشراء ، في حال زيارتك للصفحة مرة أخرى سيتم عرض منتجات مرتبطة بأخر تصفح لك.

          يتم تحليل ملفات الكوكيز، عن طريق شركاء مثل «جوجل – أدوبي» والتي تسمح لنا بتعقب تفاعلات المستخدم في الموقع والتي تعطينا رؤية واضحة تساعدنا على تحسين الموقع والمنتجات والخدمات التي نقدمها لك.
          
          قد نعمل أيضا مع شركاء يقومون بإنشاء ملفات كوكيز للطرف الثالث والتي تستخدم لاحقاً في الدعاية لتعطيك تجربة مميزة ولها علاقة باهتماماتك المحفوظة لدينا سابقاً. ونعود لنؤكد بأن هذه الكوكيز لا تحتوي أية بيانات شخصية تسمح لمواقع إلكترونية أخرى بمعرفة هويتك، حيث تبنى كلياً على بيانات تاريخ التصفح.
          
          إيقاف أو حذف الملفات المؤقتة
          
          كل متصفحات الانترنت تسمح لك بالحد أو إيقاف استخدام ملفات الكوكيز بواسطة الإعدادات أو الخيارات في المتصفح. الخطوات لفعل ذلك تختلف من متصفح لأخر، يمكنك إيجاد التعليمات الخاصة بطريقة عمل ذلك في قائمة ملف المساعدة في كل متصفح.
          
          أثناء تصفحك يمكنك أيضاً مراقبة ملفات الكوكيز التي توجد في جهازك، , وحذف بعضها أو كلها إذا أردت.
          
          الكوكيز هي ملفات نصية، لذلك يمكنك فتحها وقراءة محتوياتها . البيانات داخلها عادة ما تكون مشفرة، أو تم ترقيمها لجلسة الإنترنت، لذلك فهي غير مفهومة لأي موقع أخر عدا الموقع الذي قام بتسجيلها..  "
          />
          <Accordions
            title="ماهي الملفات المؤقتة (الكوكيز) التي يقوم موقع / تطبيق بيرين بتخزينها؟


          "
            paragraph="ملفات كوكيز التي تسجلها بيرين  تتضمن بيانات تم تسجيلها بواسطة جهاز خادم الانترنت وتتضمن معلومات عن المتصفح الذي تقوم باستخدامه، وبيانات عملية الشراء.

          ملفات الكوكيز الدائمة والتي تم إنشاءها بواسطة موقع / تطبيق بيرين يتم استخدامها بواسطة شركاؤنا، وتستخدم عادة في تمييز الزيارات الجديدة والمتكررة للموقع. البيانات المخزنة تسمح للمعلن باستهدافك بإعلانات مخصصة لك خارج موقع / تطبيق بيرين، حذف هذه الكوكيز لن يؤثر في تجربة تصفحك أو الوظائف الأساسية لموقع  بيرين
          
           
          
          تستخدم بيرين ملفات الكوكيز لإعطاء الصلاحية لبعض الوظائف الأساسية اللازمة عند تصفحك للموقع / التطبيق وشراؤك منه لحفظ المنتجات التي اضفتها لسلة الشراء، المعلومات التي يتم تجميعها في هذه الكوكيز تستخدم لهذا الغرض فقط ولن يتم مشاركتها أو بيعها لأي طرف أخر.
          
          قد يستخدم طرف ثالث بعض الكوكيز لتحسين تجربتك مثل جوجل أو أدوبي أو دبل كليك أو غيرها من أدوات إعادة الاستهداف"
          />
        </Accordion>
      </div>
    </div>
  );
}
